<template>
  <div class="container">
    <div class="menu" role="menu">
      <ul>
        <li>
          <router-link to="/">bioplan architekten</router-link>
        </li>
      </ul>
      <ul>
        <li>
          <router-link :to="{ name: 'Archive' }">archiv</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'Office' }">büro</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'Contact' }" class="active">contact</router-link>
        </li>
      </ul>
    </div>

    <div class="content">
      <LoadingSpinner v-if="isLoading"></LoadingSpinner>
      <template v-else>
        <div class="left font-regular" v-html="textHtml">
        </div>
        <div class="right">
          <iframe src="https://snazzymaps.com/embed/6656" width="100%" height="600px" style="border:none;" class="map"></iframe>
        </div>
      </template>
    </div>
    <div class="information">
      <img src="../../assets/img/bioplan_signet.png" height="57" width="72" class="signet" />
    </div>
  </div>
</template>

<script>
  import LoadingSpinner from '../parts/LoadingSpinner'
  import rest from '../../services/rest'
  import marked from 'marked'

  export default {
    name: 'Contact',
    components: {
      LoadingSpinner
    },
    data () {
      return {
        isLoading: false,
        text: ''
      }
    },
    computed: {
      textHtml () {
        return marked(this.text, { sanitize: true, breaks: true })
      }
    },
    methods: {
      loadText () {
        this.isLoading = true
        rest.pages.byName('contact', (response, hasError) => {
          if (hasError) {
            this.isLoading = false
            return
          }
          this.text = response.body.content
          this.isLoading = false
        })
      }
    },
    mounted () {
      this.loadText()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .container {
    margin-bottom: 107px;
    padding: 25px;
    color: white;
  }
  .content {
    padding-top: 25px;
  }
  .content::after {
    content:"";
    display:block;
    clear:both;
  }
  .left {
    float: left;
    width: calc((100% - 75px) / 4 - 25px);
  }
  .right {
    float: right;
    width: calc(100% - ((100% - 75px) / 4) - 35px);
    padding-top: 10px;
  }
  @media (max-width: 1199px) {
    .left {
      width: calc(100% / 3 - 40px);
    }
    .right {
      width: calc((100% / 3 * 2) - 25px);
    }
  }
  .left a {
    color: white;
    text-decoration: none;
  }
  @media (max-height: 800px) {
    .right iframe {
      height: 400px;
    }
  }
  @media (min-height: 900px) {
    .right iframe {
      height: 650px;
    }
  }
  @media (min-height: 1000px) {
    .right iframe {
      height: 750px;
    }
  }
  @media (min-height: 1100px) {
    .right iframe {
      height: 850px;
    }
  }
  @media (min-height: 1200px) {
    .right iframe {
      height: 950px;
    }
  }
  @media (min-height: 1300px) {
    .right iframe {
      height: 1050px;
    }
  }
  @media (max-width: 655px) {
    .left, .right {
      float: none;
      width: 100%;
      max-width: none;
    }
  }
</style>



// WEBPACK FOOTER //
// Contact.vue?9ee3ceea